import httpClient from './http-client';

const endpoint = 'api/contacts';

const contactService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (contact) => httpClient.post(`${endpoint}`, contact),

  update: (contact) => httpClient.put(`${endpoint}/${contact.id}`, contact),

  delete: (contact) => httpClient.delete(`${endpoint}/${contact.id}`),
};

export default contactService;
